import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Football",
    tag: "On-Pitch Mastery",
    body: "Technical work that translates to match day. Ball control, first touch, positioning, agility and game intelligence — drilled with intent until it becomes instinct. Built for players chasing the next level.",
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_coaching-book/artifacts/b1ropid8_WhatsApp%20Image%202026-08-14%20at%2003.16.58.jpeg",
    pos: "center",
  },
  {
    num: "02",
    title: "Fitness",
    tag: "Strength & Conditioning",
    body: "Programmed strength, explosive power and engine work tailored to you. We build a durable athlete — one that moves better, recovers faster, and performs when it counts. No fluff, only progress you can measure.",
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_coaching-book/artifacts/lmkujbcr_WhatsApp%20Image%202026-08-14%20at%2003.23.11.jpeg",
    pos: "center 20%",
  },
];

const rise = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

function Chapter({ c, flip }) {
  return (
    <motion.div
      data-testid={`chapter-${c.title.toLowerCase()}`}
      variants={rise}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.25 }}
      className={`grid md:grid-cols-12 gap-8 md:gap-4 items-center ${flip ? "md:[direction:rtl]" : ""}`}
    >
      <div className="md:col-span-5 [direction:ltr]">
        <div className="flex items-baseline gap-4">
          <span className="font-display font-bold text-[#2E6BE6] text-6xl md:text-7xl leading-none">{c.num}</span>
          <span className="text-white/40 text-xs uppercase tracking-[0.25em]">{c.tag}</span>
        </div>
        <h3 className="font-display font-bold uppercase tracking-tighter text-6xl md:text-7xl mt-4">{c.title}</h3>
        <p className="text-white/60 text-base md:text-lg mt-6 max-w-md font-body">{c.body}</p>
      </div>
      <div className="md:col-span-7 [direction:ltr]">
        <div className="relative overflow-hidden aspect-[4/3] border border-white/10">
          <motion.img
            initial={{ scale: 1.15 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1] }}
            src={c.img}
            alt={c.title}
            style={{ objectPosition: c.pos || "center" }}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#2E6BE6] mix-blend-color opacity-30 pointer-events-none" />
          <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
        </div>
      </div>
    </motion.div>
  );
}

export default function Manifesto() {
  return (
    <section id="work" data-testid="manifesto" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
      <motion.div
        variants={rise}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="mb-20 md:mb-32 max-w-2xl"
      >
        <span className="text-[#2E6BE6] text-xs uppercase tracking-[0.3em]">The Discipline</span>
        <h2 className="font-display font-bold uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-[0.95]">
          Two paths. One standard — relentless.
        </h2>
      </motion.div>
      <div className="space-y-28 md:space-y-40">
        {CHAPTERS.map((c, i) => (
          <Chapter key={c.num} c={c} flip={i % 2 === 1} />
        ))}
      </div>
    </section>
  );
}
